var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-screen"},[_c('div',{staticClass:"loading-container"},[_c('span',{staticClass:"loading-text"},[_vm._v("Loading")]),_c('pulse-loader',{attrs:{"size":"20px","margin":"5px","radius":"10%","color":"#9c27b0"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }